import React from "react";
import { Link } from "react-router-dom";

function STCLink(props){


    return(
        <Link
            style={props.style}
            className={props.className}
            ref={props.ref}
            as={props.as}
            validated={props.validated}
            onSubmit={props.onSubmit}
            onReset={props.onReset}
            discover={props.discover}
            prefetch={props.prefetch}
            href={props.href}
            to={props.to}
            onClick={props.onClick}
        >
            {props.children}
        </Link>
    )

}
export default STCLink;